import ClaritySDK from '@microsoft/clarity';

// Microsoft Clarity — passive heatmaps + session replay (docs/ui:ux_feature.md §4).
// A no-op until REACT_APP_CLARITY_PROJECT_ID is set, so it's safe to import
// unconditionally in every environment.
const projectId = process.env.REACT_APP_CLARITY_PROJECT_ID;

if (projectId) {
  ClaritySDK.init(projectId);
}

// Guarded wrapper so call sites (funnel events, session tags) don't need to
// check for a configured project themselves — every method below is a no-op
// when Clarity isn't initialized.
export const clarity = {
  event: (name) => { if (projectId) ClaritySDK.event(name); },
  setTag: (key, value) => { if (projectId) ClaritySDK.setTag(key, value); },
  identify: (customId) => { if (projectId) ClaritySDK.identify(customId); },
  upgrade: (reason) => { if (projectId) ClaritySDK.upgrade(reason); },
};
